import React, { useState } from "react";
import { 
  FiShield, 
  FiLock, 
  FiEye, 
  FiEyeOff, 
  FiAlertCircle,
  FiCheckCircle,
  FiX,
  FiToggleLeft,
  FiToggleRight,
  FiKey,
  FiSmartphone,
  FiActivity
} from "react-icons/fi";

const PrivacySecurityView = () => {
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [enableTwoFA, setEnableTwoFA] = useState(false);
  const [dataSharing, setDataSharing] = useState(true);
  const [sessionTimeout, setSessionTimeout] = useState("30");
  const [notifications, setNotifications] = useState(true);
  const [activityLogging, setActivityLogging] = useState(true);

  const handlePasswordChange = (e) => {
    e.preventDefault();
    
    // Simple validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      setErrorMessage("Todos los campos son obligatorios");
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setErrorMessage("Las contraseñas nuevas no coinciden");
      return;
    }
    
    if (newPassword.length < 8) {
      setErrorMessage("La contraseña debe tener al menos 8 caracteres");
      return;
    }
    
    // Success scenario
    setIsSuccess(true);
    setErrorMessage("");
    
    // Reset form after 2 seconds
    setTimeout(() => {
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setShowChangePassword(false);
      setIsSuccess(false);
    }, 2000);
  };

  const toggleChangePassword = () => {
    setShowChangePassword(!showChangePassword);
    // Reset states when closing
    if (showChangePassword) {
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setErrorMessage("");
      setIsSuccess(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="border-b p-4 bg-navy-50">
        <div className="flex items-center">
          <FiShield className="h-6 w-6 text-navy-600 mr-2" />
          <h2 className="text-xl font-semibold text-navy-900">Privacidad y Seguridad</h2>
        </div>
        <p className="text-navy-600 mt-1">Configura los ajustes de privacidad y seguridad de tu cuenta</p>
      </div>

      {/* Main content */}
      <div className="p-5">
        {/* Cambiar contraseña */}
        <div className="mb-8">
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center">
              <FiLock className="h-5 w-5 text-navy-600 mr-2" />
              <h3 className="text-lg font-medium text-navy-800">Contraseña</h3>
            </div>
            <button 
              onClick={toggleChangePassword}
              className="px-4 py-2 bg-navy-100 hover:bg-navy-200 text-navy-700 rounded-md transition duration-150"
            >
              {showChangePassword ? "Cancelar" : "Cambiar contraseña"}
            </button>
          </div>

          {showChangePassword && (
            <div className="bg-gray-100 p-4 rounded-md">
              {isSuccess ? (
                <div className="flex items-center p-3 bg-green-100 text-green-700 rounded-md mb-4">
                  <FiCheckCircle className="h-5 w-5 mr-2" />
                  <span>¡Contraseña actualizada con éxito!</span>
                </div>
              ) : errorMessage ? (
                <div className="flex items-center p-3 bg-red-100 text-red-700 rounded-md mb-4">
                  <FiAlertCircle className="h-5 w-5 mr-2" />
                  <span>{errorMessage}</span>
                  <button 
                    onClick={() => setErrorMessage("")} 
                    className="ml-auto text-red-700 hover:text-red-800"
                  >
                    <FiX className="h-4 w-4" />
                  </button>
                </div>
              ) : null}

              <form onSubmit={handlePasswordChange}>
                <div className="mb-3">
                  <label className="block text-navy-700 mb-1">Contraseña actual</label>
                  <div className="relative">
                    <input
                      type={showCurrentPass ? "text" : "password"}
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-navy-300"
                    />
                    <button
                      type="button"
                      onClick={() => setShowCurrentPass(!showCurrentPass)}
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                    >
                      {showCurrentPass ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="block text-navy-700 mb-1">Nueva contraseña</label>
                  <div className="relative">
                    <input
                      type={showNewPass ? "text" : "password"}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-navy-300"
                    />
                    <button
                      type="button"
                      onClick={() => setShowNewPass(!showNewPass)}
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                    >
                      {showNewPass ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">Mínimo 8 caracteres</p>
                </div>

                <div className="mb-4">
                  <label className="block text-navy-700 mb-1">Confirmar contraseña</label>
                  <div className="relative">
                    <input
                      type={showConfirmPass ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-navy-300"
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPass(!showConfirmPass)}
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                    >
                      {showConfirmPass ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>
                </div>

                <button
                  type="submit"
                  className="px-4 py-2 bg-navy-600 hover:bg-navy-700 text-white rounded-md transition duration-150"
                >
                  Actualizar contraseña
                </button>
              </form>
            </div>
          )}
        </div>

        {/* Autenticación de dos factores */}
        <div className="mb-8 border-t pt-6">
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center">
              <FiKey className="h-5 w-5 text-navy-600 mr-2" />
              <h3 className="text-lg font-medium text-navy-800">Autenticación de dos factores</h3>
            </div>
            <button 
              onClick={() => setEnableTwoFA(!enableTwoFA)}
              className={`flex items-center px-3 ${enableTwoFA ? 'text-navy-700' : 'text-gray-500'}`}
            >
              {enableTwoFA ? <FiToggleRight className="h-6 w-6" /> : <FiToggleLeft className="h-6 w-6" />}
            </button>
          </div>
          <p className="text-navy-600 mb-2">
            Aumenta la seguridad de tu cuenta añadiendo una capa adicional de protección al iniciar sesión.
          </p>
          {enableTwoFA && (
            <div className="bg-gray-100 p-4 rounded-md flex items-center">
              <FiSmartphone className="h-10 w-10 text-navy-600 mr-3" />
              <div>
                <p className="text-navy-700 font-medium">Autenticación vía SMS</p>
                <p className="text-navy-600 text-sm">
                  Recibirás un código de verificación en tu teléfono móvil cada vez que inicies sesión.
                </p>
                <button className="mt-2 px-3 py-1 bg-navy-600 hover:bg-navy-700 text-white rounded-md text-sm transition duration-150">
                  Configurar
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Tiempos de sesión */}
        <div className="mb-8 border-t pt-6">
          <div className="flex items-center mb-4">
            <FiActivity className="h-5 w-5 text-navy-600 mr-2" />
            <h3 className="text-lg font-medium text-navy-800">Tiempo de sesión</h3>
          </div>
          <p className="text-navy-600 mb-3">
            Selecciona cuánto tiempo debe permanecer activa tu sesión antes de cerrarse automáticamente.
          </p>
          <select
            value={sessionTimeout}
            onChange={(e) => setSessionTimeout(e.target.value)}
            className="w-full md:w-64 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-navy-300"
          >
            <option value="15">15 minutos</option>
            <option value="30">30 minutos</option>
            <option value="60">1 hora</option>
            <option value="120">2 horas</option>
            <option value="240">4 horas</option>
          </select>
        </div>

        {/* Privacidad de datos */}
        <div className="mb-8 border-t pt-6">
          <h3 className="text-lg font-medium text-navy-800 mb-4">Privacidad de datos</h3>
          
          <div className="flex justify-between items-center py-3">
            <div>
              <p className="text-navy-700 font-medium">Compartir datos para mejorar el servicio</p>
              <p className="text-navy-600 text-sm">
                Permitir el uso anónimo de datos para mejorar la calidad del servicio
              </p>
            </div>
            <button 
              onClick={() => setDataSharing(!dataSharing)}
              className={`flex items-center px-3 ${dataSharing ? 'text-navy-700' : 'text-gray-500'}`}
            >
              {dataSharing ? <FiToggleRight className="h-6 w-6" /> : <FiToggleLeft className="h-6 w-6" />}
            </button>
          </div>
          
          <div className="flex justify-between items-center py-3">
            <div>
              <p className="text-navy-700 font-medium">Registro de actividad</p>
              <p className="text-navy-600 text-sm">
                Mantener un registro de actividad para mayor seguridad
              </p>
            </div>
            <button 
              onClick={() => setActivityLogging(!activityLogging)}
              className={`flex items-center px-3 ${activityLogging ? 'text-navy-700' : 'text-gray-500'}`}
            >
              {activityLogging ? <FiToggleRight className="h-6 w-6" /> : <FiToggleLeft className="h-6 w-6" />}
            </button>
          </div>
          
          <div className="flex justify-between items-center py-3">
            <div>
              <p className="text-navy-700 font-medium">Notificaciones de seguridad</p>
              <p className="text-navy-600 text-sm">
                Recibir notificaciones sobre intentos de inicio de sesión o cambios en la cuenta
              </p>
            </div>
            <button 
              onClick={() => setNotifications(!notifications)}
              className={`flex items-center px-3 ${notifications ? 'text-navy-700' : 'text-gray-500'}`}
            >
              {notifications ? <FiToggleRight className="h-6 w-6" /> : <FiToggleLeft className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Botones de acciones */}
        <div className="flex justify-end space-x-4 pt-4 border-t">
          <button className="px-4 py-2 border border-navy-600 text-navy-600 hover:bg-navy-50 rounded-md transition duration-150">
            Cancelar
          </button>
          <button className="px-4 py-2 bg-navy-600 hover:bg-navy-700 text-white rounded-md transition duration-150">
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacySecurityView;